import {Design} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {ButtonSize, ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {MLogo} from '@mintdata-wsp/wsp/ui/components/logo/MLogo';
import {PublishDialogKind} from '@mintdata-wsp/wsp/ui/dialogs/publish/PublishDialog';
import {ExpandedTopMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/ExpandedTopMenu';
import {ProfileButton} from '@mintdata-wsp/wsp/ui/views/workspace/userBar/profile/ProfileButton';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {TopBarUserIconList} from '@mintdata-wsp/wsp/ui/views/visualDesigner/header/userPresence/TopBarUserIconList';
import {UserIconSize} from '@mintdata-wsp/wsp/ui/views/visualDesigner/header/userPresence/UserIcon';

const styles = require('./VisualDesignerHeader.less');
const cx = classnames.bind(styles);

@observer
export class VisualDesignerHeader extends React.Component<any, any>
{
    public render():JSX.Element
    {
        if (controllers.ui.openDesign.isInSampleDesignMode())
            return null;

        const isExpanded:boolean = controllers.ui.topMenu.isTopMenuExpanded();
        const isLogoTransitionInProgress:boolean = controllers.ui.topMenu.isLogoTransitionInProgress();

        const {designId} = controllers.ui.openDesign.getOpenDesign().designRef;
        const design:Design = rootState.ui.mainPage.currentDesigns.find(({id}) => id === designId);

        return (
            <div
                className={cx('base', {isVisible: isExpanded && !isLogoTransitionInProgress})}
                onTransitionEnd={() => controllers.ui.topMenu.endTopMenuTransition()}
            >
                <div className={cx('container')}>
                    <MLogo tooltipProps={{content: 'Go to Workspace'}} />
                    <div className={cx('topMenuContainer')}>
                        <div className={cx('designName')}>
                            {design.name}
                        </div>
                        <ExpandedTopMenu />
                    </div>
                    <TopBarUserIconList iconSize={UserIconSize.Large} />
                    <WSPButton caption={'Publish'}
                               className={cx('publishButton')}
                               style={ButtonStyle.Simple}
                               size={ButtonSize.Medium}
                               icon={<WSPIcon className={cx('publishIcon')}
                                              name={WSPIcons.visualDesigner.topBar.Publish} />}
                               onClick={this._handlePublishClick}
                    />
                    <ProfileButton
                        className={cx('profileButton')}
                        captionClassName={cx('profileButtonCaption')}
                    />
                </div>
            </div>
        );
    }

    private _handlePublishClick = (event:React.MouseEvent<HTMLElement>) =>
    {
        const {openDesign, publish} = controllers.ui;

        publish.showPublishDialog({
            designRef: openDesign.getOpenDesign().designRef,
            kind: PublishDialogKind.Full
        }, true);
    };
}
